declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

const PIXEL_ID = '966263356035957'
let initialized = false

export const initPixel = () => {
  if (typeof window === 'undefined' || initialized) return
  initialized = true
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = !0
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

export const trackAddToCart = (params?: {
  value?: number
  currency?: string
  content_name?: string
  content_ids?: string[]
}) => {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'AddToCart', params)
}
